<template>
  <div id="prefs">
    <h2>Translators</h2>
    <v-layout column wrap>
      <v-layout row wrap>
        <v-flex style="border: 1px solid grey;padding: 5px;">
          <v-autocomplete :label="'Select Translator Table'" v-model="selectedPref" :items="transSelectSorted">
          </v-autocomplete>
        </v-flex>
        <v-layout column style="margin-left: 30px">
          <v-flex style="border: 1px solid grey;padding: 5px;">
            <v-text-field label="Table Name" v-model="newTableName">
            </v-text-field>
            <v-layout row wrap>
              <v-flex>
                <v-btn small color="success" class="ma-3" style="margin: 0px;" @click="createNewTable" :disabled="disableButton">Add New Table</v-btn>
                <v-btn class="ma-3" small color="error" style="margin: 0px;" @click="deleteTable" :disabled="disableDelete">Delete Table</v-btn>
                <v-label style='color: red;' class="ma-3" v-if="newTableName != null && newTableName.substring(0,4) != 'sch_'">Names must begin with sch_</v-label>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-layout>
    <v-card>
    <server-table-component 
      server="login" 
      v-if="selectedPref != null" 
      :newtable="selectedPref" 
      :table="selectedPref"
      :refresh="true" 
      schema="sch_schema"
    >
    </server-table-component>
    </v-card>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import utils from '@/../../coreui/helpers/utils'
import axiosInstances from '@/../../coreui/server/axiosInstances'

export default {
  data: () => ({
    transSelect: [],
    selectedPref: null,
    db: 'auth',
    newTableName: '',
    editPref: '',
  }),
  computed: {
    disableButton() {
      if (this.newTableName != '' && this.transSelect.indexOf(this.newTableName) == -1 && this.newTableName != null && this.newTableName.substring(0,4) == 'sch_') {
        return false
      } else {
        return true
      }
    },
    disableDelete () {
      return !this.transSelect.includes(this.newTableName)
    },
    transSelectSorted () {
      return this.transSelect.sort()
    },
    auth: function () {
      if (this.db == 'auth' || this.db == 'loginServer') return this.db
      return null
    }
  },
  methods: {
    async initialize () {
      let cols = await axiosInstances.loginServer.get('/dt/v1/collections')
      this.transSelect = cols.data.filter(i => i.substring(0, 4) == 'sch_')
    },
    createNewTable () {
      this.transSelect.push(this.newTableName)
      this.selectedPref = this.newTableName
    },
    deleteTable () {
      var self = this
      this.$root.$confirm('Delete', 'Delete schema: ' + this.newTableName +'? ', { color: 'red' }) 
      .then(async function (confirm) {
        if (confirm) { 
          await axiosInstances.loginServer.delete('/dt/v1/collections/'+self.newTableName)
          self.transSelect.splice(self.transSelect.indexOf(self.newTableName, 1))
          self.selectedPref = null
        }
      })
    },
  },
  mounted () {
    this.initialize()
  },
  beforeDestroy () {
  },
  created () {
  }
}
</script>

<style scoped>
#prefs {
  margin: 20px;
}
</style>
